var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconAddFolder = function SvgIconAddFolder(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.32 5.32 12 7h6.68q.703 0 1.172.508.468.468.468 1.171V17q0 .704-.468 1.173a1.73 1.73 0 0 1-1.172.507H5.32a1.73 1.73 0 0 1-1.172-.507Q3.68 17.702 3.68 17V7q0-.705.468-1.172A1.73 1.73 0 0 1 5.32 5.32zM14.5 9.5V12H12v1.68h2.5v2.5h1.68v-2.5h2.5V12h-2.5V9.5z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconAddFolder);
export { ForwardRef as ReactComponent };